import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const titles = {
	legend: 'legenda',
	organizationStructure: 'organizační struktura',
	sendNotification: 'zasílání notifikací',
	contactDetail: 'Detail kontaktu',
};

const buttons = {
	statistics: 'statistika úkolů',
	submit: 'předat',
	save: 'Uložit',
	revertChanges: 'Vrátit změny',
	deleteConfiguration: 'Vymazat nastavení',
	processInformation: 'zpracovat informace',
	print: 'tisk',
	taskSearch: 'Vyhledat úkol',
	loadFromTempalte: 'Načíst ze šablony',
	saveTemplate: 'Uložit šablonu',
	export: 'export',
	restoreContacts: 'Vrátit kontakty',
};

const dropdowns = {
	channel: 'Kanál',
	edkChannel: 'EDK kanál',
	region: 'Region',
	agency: 'Oblast',
	manager: 'Manažer',
	seller: 'Obchodník',
	ppz: 'Podobchodník',
};

const icons = {
	tasks: 'Úkoly',
	information: 'Informace',
	inTime: 'V termínu',
	deadlineIsNear: 'Blíží se termín splnění',
	afterDeadline: 'Po termínu',
	unread: 'Nepřečtené',
	done: 'Zpracované',
	taskViewFlag: 'Příznak zobrazení úkolu',
	unreadAndSum: 'Nepřečteno/Přijato',
};

const tooltips = {
	contactAddress: 'korespondenční adresa',
	permanentAddress: 'adresa trvalého bydliště',
};

const merge = {
	...titles,
	...buttons,
	...dropdowns,
	...icons,
	...tooltips,
};

export default Object.assign({}, merge, createLabeledMessages(merge));
